import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Breadcrumbs from "../common/Breadcrumbs";
import { Link, useLocation } from "react-router-dom";
// import Select from "react-select";
import { all_routes } from "../router/all_routes";
// import ListingSidebar from "./listingsidebar";
import { useDispatch, useSelector } from "react-redux";
// import { listgrids } from "../../core/data/interface/interface";
import Aos from "aos";
import { AppDispatch, RootState } from "../../core/data/redux/store";
import { fetchVehicles } from "../../core/data/redux/action";
import ImageWithURL from "../../core/data/img/ImageWithURL";

const ListingGrid = () => {
  // const data = useSelector((state: listgrids) => state.listing_grid);

  const dispatch: AppDispatch = useDispatch();

  // Local state for vehicles
  const [localVehicles, setLocalVehicles] = useState<any[]>([]);
  console.log("localVehicles", localVehicles);
  // Fetch vehicles from Redux store
  const vehicles = useSelector((state: RootState) => state.vehicles);
  const location = useLocation();

  const getCategory = () => {
    const params = new URLSearchParams(location.search);
    return params.get("category");
  };

  const category = getCategory();

  // Fetch vehicles when component mounts
  useEffect(() => {
    dispatch(fetchVehicles(category));
  }, [dispatch, location]);

  // Synchronize local state with Redux state
  useEffect(() => {
    setLocalVehicles(vehicles.data);
  }, [vehicles]);

  const [minLoadTimeElapsed, setMinLoadTimeElapsed] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setMinLoadTimeElapsed(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  const routes = all_routes;
  // const options = [
  //   { value: 5, label: "5" },
  //   { value: 10, label: "10" },
  //   { value: 15, label: "15" },
  //   { value: 20, label: "20" },
  // ];
  // const optionsTwo = [
  //   { value: 1, label: "Low to High" },
  //   { value: 2, label: "High to Low" },
  // ];

  // const optionsThree = [
  //   { value: "popular", label: "Popular" },
  //   { value: "toyota", label: "Toyota Camry SE 350" },
  //   { value: "audi", label: "Audi A3 2019 new" },
  //   { value: "ferrari", label: "Ferrari 458 MM Speciale" },
  //   { value: "chevrolet", label: "Chevrolet Camaro" },
  //   { value: "acura", label: "Acura Sport Version" },
  // ];
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <>
      <Helmet>
        <title>Browse our elite luxury fleet - Eleego</title>
        <meta name="description" content="Browse our elite luxury fleet of rental cars and chauffeur services at Eleego." />
      </Helmet>
      <div className="main-wrapper">
        <Breadcrumbs title="Car Listings" subtitle="Car Listings" maintitle="" />
      {/* <div className="sortby-sec">
        <div className="container">
          <div className="sorting-div">
            <div className="row d-flex align-items-center">
              <div className="col-xl-4 col-lg-3 col-sm-12 col-12">
                <div className="count-search">
                  <p>
                    Showing <span>1-8</span> of 10 Results
                  </p>
                </div>
              </div>
              <div className="col-xl-8 col-lg-9 col-sm-12 col-12">
                <div className="product-filter-group">
                  <div className="sortbyset">
                    <span className="sortbytitle">Show : </span>
                    <div className="sorting-select select-one">
                      <Select
                        className="select w-100"
                        options={options}
                        placeholder="5"
                        isSearchable={false}
                      />
                    </div>
                    <div className="sorting-select select-two">
                      <Select
                        className="select w-100"
                        options={optionsTwo}
                        placeholder="Low to High"
                        isSearchable={false}
                      />
                    </div>
                    <div className="sorting-select select-three">
                      <Select
                        className="select"
                        options={optionsThree}
                        placeholder="Popular"
                        aria-labelledby="carDropdownLabel"
                        isSearchable={false}
                      />
                    </div>
                  </div>
                  <div className="grid-listview">
                    <ul>
                      <li>
                        <Link to={routes.listinggrid} className="active">
                          <i className="feather icon-grid"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to={routes.listinglist}>
                          <i className="feather icon-list"> </i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <section className="section car-listing">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3 col-12 theiaStickySidebar">
              <div className="stickybar">
                <ListingSidebar />
              </div>
            </div> */}
            <div className="col-lg-12 justify-content-center text-center align-items-center">
              <div className="row">
                {/* col */}
                {localVehicles && localVehicles.length && minLoadTimeElapsed ? (
                  localVehicles.map((item: any, index: number) => (
                    <div
                      key={index}
                      className="col-xl-3 col-lg-6 col-md-6 col-12"
                      data-aos="fade-up"
                      data-aos-duration="1000"
                      data-aos-delay={(index % 4) * 150}
                    >
                      <div className="lux-vehicle-card">
                        {/* Image with overlay + category badge */}
                        <Link to={`${routes.listingdetails}?id=${item.id}`} className="lux-vehicle-img-wrap">
                          <ImageWithURL
                            src={item.image_url}
                            className="lux-vehicle-img"
                            alt={item.name}
                          />
                          <div className="lux-vehicle-img-gradient" />
                          {item.category && (
                            <span className="lux-vehicle-badge">
                              {item.category}
                            </span>
                          )}

                        </Link>

                        {/* Content */}
                        <div className="lux-vehicle-content">
                          <h3 className="lux-vehicle-title">
                            <Link to={`${routes.listingdetails}?id=${item.id}`}>
                              {item.name}
                            </Link>
                          </h3>

                          {item.brand_name && (
                            <p className="lux-vehicle-brand">{item.brand_name}</p>
                          )}

                          <div className="lux-vehicle-divider" />

                          <Link
                            to={`${routes.listingdetails}?id=${item.id}`}
                            className="lux-vehicle-cta"
                          >
                            {item.category === "Rental" ? (
                              <><i className="fa-solid fa-key me-2" />Rent Now</>
                            ) : (
                              <><i className="fa-regular fa-envelope me-2" />Get a Quote</>
                            )}
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center w-100" style={{ height: "60vh" }}>
                    <div style={{ position: "relative", width: "80px", height: "80px" }}>
                      <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", animation: "spin 3s linear infinite" }}>
                        <circle cx="50" cy="50" r="45" fill="none" stroke="var(--luxury-gold)" strokeWidth="2" strokeDasharray="141 141" strokeDashoffset="0" />
                        <path d="M50 5 a45 45 0 0 1 45 45" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2" />
                        <circle cx="50" cy="50" r="2" fill="var(--luxury-gold)" />
                        <path d="M50 5 L50 95 M5 50 L95 50 M18 18 L82 82 M18 82 L82 18" stroke="var(--luxury-gold)" strokeWidth="1" opacity="0.3" />
                        <ellipse cx="50" cy="50" rx="45" ry="15" fill="none" stroke="var(--luxury-gold)" strokeWidth="1" opacity="0.5" transform="rotate(20 50 50)" />
                        <ellipse cx="50" cy="50" rx="45" ry="15" fill="none" stroke="var(--luxury-gold)" strokeWidth="1" opacity="0.5" transform="rotate(-20 50 50)" />
                      </svg>
                      <div style={{
                        position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                        width: "40px", height: "40px", background: "radial-gradient(circle, var(--luxury-gold) 0%, transparent 70%)",
                        opacity: "0.2", animation: "pulse 2s ease-in-out infinite"
                      }} />
                    </div>
                    <p className="mt-4 mb-0 lux-eyebrow" style={{ color: "var(--luxury-gold)", letterSpacing: "4px" }}>
                      ACCESSING FLEET
                    </p>
                    <style>
                      {`
                        @keyframes spin { 100% { transform: rotate(360deg); } }
                        @keyframes pulse { 0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.2; } 50% { transform: translate(-50%, -50%) scale(1.5); opacity: 0.4; } }
                      `}
                    </style>
                  </div>
                )}
                {/* /col */}
                {/* col */}
              </div>
              {/*Pagination*/}
              {/* <div className="blog-pagination">
                <nav>
                  <ul className="pagination page-item justify-content-center">
                    <li className="previtem">
                      <Link className="page-link" to="#">
                        <i className="fa-solid fa-arrow-left"></i>
                        Prev
                      </Link>
                    </li>
                    <li className="justify-content-center pagination-center">
                      <div className="page-group">
                        <ul>
                          <li className="page-item">
                            <Link className="page-link" to="#">
                              1
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link className="active page-link" to="#">
                              2{" "}
                              <span className="visually-hidden">(current)</span>
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link className="page-link" to="#">
                              3
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link className="page-link" to="#">
                              4
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link className="page-link" to="#">
                              5
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="nextlink">
                      <Link className="page-link" to="#">
                        Next{" "}
                        <i className="fas fa-regular fa-arrow-right ms-2"></i>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div> */}
              {/*/Pagination*/}
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default ListingGrid;
